import { z } from 'zod';
import { TextItem } from './common';
export var PreventingRelapseStrategy = TextItem;
export var PreventingRelapseReasonEnum = {
    LOSS: 'LOSS',
    FINANCIAL: 'FINANCIAL',
    CONFLICT: 'CONFLICT',
    STRESS: 'STRESS',
    CHANGES: 'CHANGES',
    HOLIDAYS: 'HOLIDAYS',
    VACATIONS: 'VACATIONS',
    OTHER: 'OTHER'
};
export var PreventingRelapse = z.object({
    relapsePlans: z.array(z.object({
        reason: z.nativeEnum(PreventingRelapseReasonEnum),
        reasonLabel: z.string().optional(),
        strategies: z.array(PreventingRelapseStrategy)
    }))
}).prefault({
    relapsePlans: []
});
